(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ab-desktop-navigation"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ab-lighting-navigation')) {
  customElements.define('ab-lighting-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.querySelectorAll('details[open]').forEach(item => item.open = false);
      }, options);
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const open = this.querySelector('details[open]');
        if (open) { open.open = false; open.querySelector('summary').focus(); }
      }, options);
      const hover = window.matchMedia('(min-width: 768px) and (hover: hover) and (pointer: fine)');
      this.querySelectorAll('details').forEach(item => {
        item.addEventListener('pointerenter', event => {
          if (!hover.matches || event.pointerType !== 'mouse') return;
          this.querySelectorAll('details[open]').forEach(other => { if (other !== item) other.open = false; });
          item.open = true;
        }, options);
        item.addEventListener('pointerleave', event => {
          if (hover.matches && event.pointerType === 'mouse' && !item.contains(document.activeElement)) item.open = false;
        }, options);
        item.addEventListener('focusout', event => {
          if (hover.matches && !item.contains(event.relatedTarget) && !item.matches(':hover')) item.open = false;
        }, options);
      });
      hover.addEventListener('change', () => {
        this.querySelectorAll('details[open]').forEach(item => item.open = false);
      }, options);
      this.querySelectorAll('details').forEach(item => item.addEventListener('toggle', () => {
        if (item.open) this.querySelectorAll('details[open]').forEach(other => { if (other !== item) other.open = false; });
      }, options));
    }
    disconnectedCallback() { if (this.controller) this.controller.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
